// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__C1AIb","ctDialog":"styles_ctDialog__3rNpo","headModal":"styles_headModal__3UeeA","iconClose":"styles_iconClose__1wDu4"};